import store from '@shared/store/index';
import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName';

/**
 * Открывает одиночное изображение в слайдере.
 *
 * @param {string} src - Ссылка на изображение, которое нужно открыть.
 * @param {string} [caption] - Необязательная подпись к изображению.
 * @returns {void}
 */
export const sliderImageDisplay = (src, caption) => {
  const data = [{ url: src, caption }];
  store.dispatch('Slider/activeSlider', { data: data, index: 0 });
  store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.slider);
};

/**
 * Открывает слайдер с группой изображений.
 *
 * @param {Array<{ url: string, caption?: string }>} arr - Массив объектов изображений.
 *        Каждый объект должен содержать поле `url`, и может содержать `caption` - подпись к изображению.
 * @param {number} [index=0] - Индекс изображения, с которого начать просмотр.
 * @returns {void}
 */
export const sliderImagesGroupDisplay = (arr, index = 0) => {
  store.dispatch('Slider/activeSlider', { data: arr, index: index });
  store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.slider);
};